import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Fa from 'react-fontawesome';
import { find } from 'lodash';
import { Modal, Button } from 'react-bootstrap';
import { getDeletingColumn } from './reducer';
import { requestDeleteColumn } from './actions';
import {
  deleteTablePreferenceColumn,
  loadTablePreferenceMetaData,
} from '../../modules/App/AppActions';
import {
  getTablePreferenceMetaData,
} from '../../modules/App/AppReducer';
import { deleteMeta } from '../custom-meta/actions';

class DeleteColumnModal extends Component {
  constructor() {
    super();
    this.state = {
      disabled: false,
      open: false,
      loaded: false,
      deleteMeta: true,
    };
    this.cancel = this.cancel.bind(this);
    this.confirmDelete = this.confirmDelete.bind(this);
    this.toggleDeleteMeta = this.toggleDeleteMeta.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    let open = false;
    if (nextProps.tableId) {
      open = nextProps.tableId !== null;
    }
    if (this.state.open !== open) {
      this.setState({ open });
    }
    if (open && !this.state.loaded) {
      this.setState({ loaded: true });
      this.props.dispatch(loadTablePreferenceMetaData());
    }
    if (!open) {
      this.setState({ deleteMeta: false });
    }
  }

  cancel() {
    if (!this.state.disabled) {
      this.props.dispatch(requestDeleteColumn(null, null));
    }
  }

  toggleDeleteMeta() {
    const { disabled } = this.state;
    if (!disabled) {
      this.setState({ deleteMeta: !deleteMeta });
    }
  }

  confirmDelete() {
    if (!this.state.disabled) {
      const { tableId, column } = this.props;
      const isCustomMetaColumn = column && column.target_custom_meta_id !== null && column.target_custom_meta_id !== undefined;
      this.setState({ disabled: true });
      this.props.dispatch(deleteTablePreferenceColumn(tableId, column._id))
        .then(
          () => {
            if (isCustomMetaColumn && this.state.deleteMeta) {
              this.props.dispatch(deleteMeta(column.target_custom_meta_id))
                .then(
                  () => {
                    this.setState({ disabled: false });
                    this.cancel();
                  },
                  () => {
                    this.setState({ disabled: false });
                    this.cancel();
                  },
                );
            } else {
              this.setState({ disabled: false });
              this.cancel();
            }
          },
          () => {
            this.setState({ disabled: false });
          },
        );
    }
  }

  renderDeleteMetaMessage() {
    const { column, metaData } = this.props;
    const isCustomMetaColumn = column && column.target_custom_meta_id !== null && column.target_custom_meta_id !== undefined;
    let meta;
    if (isCustomMetaColumn) {
      const objectData = find(metaData, { type: column.target_object });
      if (objectData) {
        meta = find(objectData.custom_fields, { _id: column.target_custom_meta_id });
      }
    }
    if (meta !== undefined) {
      return (
        <table
          className="table table-condensed"
          onClick={this.toggleDeleteMeta}
          style={{ cursor: 'pointer' }}
        >
          <tbody>
            <tr>
              <td width="20">
                <Fa
                  name={deleteMeta ? 'check-square-o' : 'square-o'}
                  className={deleteMeta ? 'text-danger' : ''}
                />
              </td>
              <td className={deleteMeta ? 'text-danger' : 'text-muted'}>
                Also delete the custom field <code>{meta.label}</code> and all of its associated data.
              </td>
            </tr>
          </tbody>
        </table>
      );
    }
    return null;
  }

  render() {
    const { tableId, isRow, column } = this.props;
    const { disabled, open } = this.state;
    const isCustomMetaColumn = column && column.target_custom_meta_id !== null && column.target_custom_meta_id !== undefined;
    const label = isRow ? 'Row' : 'Column';
    return (
      <Modal
        show={open}
        onHide={this.cancel}
        bsSize="sm"
      >
        <Modal.Header closeButton>
          Deleting Table {label}
        </Modal.Header>
        <Modal.Body>
          <div className="well well-sm">
            {tableId !== null &&
              <div>
                <p>Are you sure you want to delete the <code>{column.label}</code> {label}?</p>
                {isCustomMetaColumn && <p>This column also has custom associated data linked to it.</p>}
                <p>This action cannot be undone.</p>
              </div>
            }
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className="clearfix">
            <Button
              bsStyle="link"
              disabled={disabled}
              className="pull-left"
              onClick={this.cancel}
            >
              Cancel
            </Button>
            <Button
              bsStyle="danger"
              disabled={disabled}
              className="pull-right"
              onClick={this.confirmDelete}
            >
              <Fa name={disabled ? 'spinner' : 'trash'} spin={disabled} /> Delete {label}
            </Button>
          </div>
        </Modal.Footer>
      </Modal>
    );
  }
}


DeleteColumnModal.propTypes = {
  dispatch: PropTypes.func.isRequired,
  tableId: PropTypes.string,
  column: PropTypes.shape({}),
  isRow: PropTypes.bool,
  metaData: PropTypes.arrayOf(PropTypes.shape({
    type: PropTypes.string,
    fields: PropTypes.arrayOf(PropTypes.shape({
      label: PropTypes.string,
      name: PropTypes.string,
      description: PropTypes.string,
    })),
  })).isRequired,
};
DeleteColumnModal.defaultProps = {
  tableId: null,
  column: null,
  isRow: false,
};
function mapStateToProps(state) {
  const deletingColumn = getDeletingColumn(state);
  return {
    tableId: deletingColumn ? deletingColumn.tableId : null,
    column: deletingColumn ? deletingColumn.column : null,
    metaData: getTablePreferenceMetaData(state),
  };
}
export default connect(mapStateToProps)(DeleteColumnModal);
